// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction
/* eslint-disable jira/i18n/id-named-by-package */
import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	headerMessage: {
		id: 'issue.details.web-links.delete-confirmation-modal.title',
		defaultMessage: 'Delete the web link?',
		description: 'A header to explain this modal is used to delete the web link.',
	},
	contentMessage: {
		id: 'issue.details.web-links.delete-confirmation-modal.content',
		defaultMessage: 'You can add the link later again if you need to.',
		description: 'Content letting users know that web links can be added again.',
	},
	confirmActionText: {
		id: 'issue.details.web-links.delete-confirmation-modal.confirmation-text',
		defaultMessage: 'Delete',
		description: 'Confirmation button that will delete the web link when clicked.',
	},
	cancelActionText: {
		id: 'issue.details.web-links.delete-confirmation-modal.cancellation-text',
		defaultMessage: 'Cancel',
		description: 'Cancel button that will close the modal and cancel the operation.',
	},
});

export default messages;
